import { Link } from "react-router-dom";
import { Building2, Users, Crown, User2, ArrowUpRight } from "lucide-react";

/**
 * TierContextHeader — reframes the dashboard greeting based on the
 * caller's maturity tier. Same KPIs, tier-appropriate lens through the
 * Athlete Performance Operating System™ narrative:
 *
 *   - Athlete    → "Your intelligence layer"
 *   - Team       → "Your team's intelligence layer"
 *   - Performance→ "Your performance department"
 *   - Enterprise → "Your organization view"
 */
const FRAMING = {
  athlete: {
    Icon: User2, tagline: "Athlete · Your Intelligence Layer.",
    headline: "Movement, performance, workload, recovery — connected today.",
    accent: "#22D3EE",
  },
  team: {
    Icon: Users, tagline: "Team · Athlete Performance OS.",
    headline: "One athlete. One record. One intelligence layer.",
    accent: "var(--brand-secondary)",
  },
  performance: {
    Icon: Building2, tagline: "Performance · One Unified Department.",
    headline: "Coaches, ATs, S&C, and sports medicine — coaching the same athlete.",
    accent: "var(--brand-secondary)",
  },
  enterprise: {
    Icon: Crown, tagline: "Enterprise · Organization Intelligence.",
    headline: "Every affiliate on the same intelligence platform.",
    accent: "#FFD700",
  },
};

export default function TierContextHeader({ tierInfo }) {
  if (!tierInfo) return null;
  const cfg = FRAMING[tierInfo.tier] || FRAMING.team;
  const Icon = cfg.Icon;
  return (
    <div
      className="flex items-end justify-between flex-wrap gap-3"
      data-testid="tier-context-header"
      data-tier={tierInfo.tier}
    >
      <div>
        <div className="flex items-center gap-2 text-[10px] tracking-[0.3em] font-bold uppercase"
             style={{ color: cfg.accent }} data-testid={`tier-context-header-${tierInfo.tier}`}>
          <Icon className="h-3.5 w-3.5" /> {cfg.tagline}
        </div>
        <h1 className="font-display font-black text-3xl md:text-5xl tracking-tighter mt-1 text-white leading-[1.05]">
          {cfg.headline}
        </h1>
      </div>
      {tierInfo.tier === "enterprise" && (
        <Link to="/dashboard/executive" className="text-xs tracking-[0.15em] uppercase font-bold text-white/55 hover:text-white inline-flex items-center gap-1"
          data-testid="tier-context-executive-link">
          Executive dashboard <ArrowUpRight className="h-3.5 w-3.5" />
        </Link>
      )}
    </div>
  );
}
